import { render, staticRenderFns } from "./WebsiteMigrationsList.vue?vue&type=template&id=65b67da9&"
import script from "./WebsiteMigrationsList.vue?vue&type=script&lang=ts&"
export * from "./WebsiteMigrationsList.vue?vue&type=script&lang=ts&"
import style0 from "./WebsiteMigrationsList.vue?vue&type=style&index=0&id=65b67da9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports